module.exports = __webpack_public_path__ + "static/media/bridge.5ad72805.jpeg";